import { EventWithSubEvents } from '@lib/types/EventWithSubEvents';
import { Box, Typography, useTheme } from "@mui/material";
import { FC } from 'react';
import EventList from './EventList';

interface OlderEventsYearGroupProps {
    year: string;
    events: EventWithSubEvents[];
    selectedEventIds?: string[];
    onSelectionChange?: (eventId: string) => void;
}

/**
 * Component for displaying events grouped by year in the "Older" section
 */
const OlderEventsYearGroup: FC<OlderEventsYearGroupProps> = ({ year, events, selectedEventIds, onSelectionChange }) => {
    const theme = useTheme();

    return (
        <Box key={`older-year-${year}`} sx={{ ml: 2, mb: 2 }}>
            <Typography
                variant="subtitle1"
                sx={{
                    mb: 1,
                    color: theme.palette.text.secondary,
                    fontWeight: theme.typography.fontWeightMedium,
                }}
            >
                {year}
            </Typography>
            <EventList
                events={events}
                keyPrefix="older"
                selectedEventIds={selectedEventIds}
                onSelectionChange={onSelectionChange}
            />
        </Box>
    );
};

export default OlderEventsYearGroup;
